export default __webpack_public_path__ + "static/media/coins.f58ae3c1.svg";